import { logger } from "@pandas/logger";

type ModelCache = { modelUrls: Array<string>; serveFromCacheIfPrefixIs: string };

const mediaPipeWasmFiles = {
	modelUrls: [
		"https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/face_detection_solution_simd_wasm_bin.wasm",
		"https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/face_detection_short_range.tflite",
		"https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/face_detection_solution_simd_wasm_bin.js",
		"https://cdn.jsdelivr.net/npm/@mediapipe/face_detection/face_detection_short.binarypb",
		"https://cdn.jsdelivr.net/npm/@mediapipe/hands/hands_solution_packed_assets.data",
		"https://cdn.jsdelivr.net/npm/@mediapipe/hands/hand_landmark_lite.tflite",
		"https://cdn.jsdelivr.net/npm/@mediapipe/hands/hands_solution_simd_wasm_bin.wasm",
		"https://cdn.jsdelivr.net/npm/@mediapipe/hands/hands_solution_simd_wasm_bin.js",
		"https://cdn.jsdelivr.net/npm/@mediapipe/hands/hands.binarypb",
		"https://cdn.jsdelivr.net/npm/@mediapipe/hands/hands_solution_packed_assets_loader.js",
	],
	serveFromCacheIfPrefixIs: "https://cdn.jsdelivr.net/npm/@mediapipe/",
};
const cocoSSDModelCache = {
	modelUrls: [
		"https://storage.googleapis.com/tfjs-models/savedmodel/ssdlite_mobilenet_v2/model.json",
		"https://storage.googleapis.com/tfjs-models/savedmodel/ssdlite_mobilenet_v2/group1-shard1of5",
		"https://storage.googleapis.com/tfjs-models/savedmodel/ssdlite_mobilenet_v2/group1-shard2of5",
		"https://storage.googleapis.com/tfjs-models/savedmodel/ssdlite_mobilenet_v2/group1-shard3of5",
		"https://storage.googleapis.com/tfjs-models/savedmodel/ssdlite_mobilenet_v2/group1-shard4of5",
		"https://storage.googleapis.com/tfjs-models/savedmodel/ssdlite_mobilenet_v2/group1-shard5of5",
	],
	serveFromCacheIfPrefixIs: "https://storage.googleapis.com/tfjs-models/",
};
const cacheName = "model-cache";

export default async function ActivateServiceWorker(useServiceWorker: boolean, detectionVersion: string) {
	const modelCache: ModelCache = detectionVersion === "v2" ? mediaPipeWasmFiles : cocoSSDModelCache;
	const serviceWorkerAvailable = "serviceWorker" in navigator;
	logger.info(
		"INFO",
		`Service worker enabled:${useServiceWorker} avail:${serviceWorkerAvailable} version: ${detectionVersion}`,
	);
	if (useServiceWorker && serviceWorkerAvailable) {
		await navigator.serviceWorker.register("/service-worker.js", { scope: "./" });
		navigator.serviceWorker.ready.then((registration) => {
			if (registration.active)
				registration.active.postMessage({
					type: "cache-ai-models",
					modelUrls: modelCache.modelUrls,
					cachePrefix: modelCache.serveFromCacheIfPrefixIs,
				});
		});
	} else {
		LoadCache(modelCache);
	}
}
async function LoadCache(modelCache: ModelCache) {
	if (window.caches)
		await window.caches.open(cacheName).then((cache) => {
			modelCache.modelUrls.forEach(async (shard) => {
				cache.add(shard);
			});
		});
	else logger.warning("INFO", { action: "load-cache", message: "Window caches is undefined" });
}
